import { render, staticRenderFns } from "./fanpai.vue?vue&type=template&id=3b4760c4&"
import script from "./fanpai.vue?vue&type=script&lang=js&"
export * from "./fanpai.vue?vue&type=script&lang=js&"
import style0 from "./fanpai.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports